import { httpCreate } from './http';

const http = httpCreate('/views');

export const views = {
	getToken() {
		return http.get('/wechat-login/authToken');
	},
	doBind(data) {
		return http.post('/wechat-login/doBind', data);
	},
	doUnBind() {
		return http.post('/wechat-login/doUnBind');
	},
};
